// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

// view all appointments
export const viewAppointment = createAsyncThunk(
  "appointment",
  async (thunkAPI) => {
    try {
      //response
      let response = await axios.get(`${BaseUrl}backend-api/appointments`);

      // condition
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// get single appointments
export const singleAppointment = createAsyncThunk(
  "appointment",
  async (id, thunkAPI) => {
    try {
      //response
      let response = await axios.get(
        `${BaseUrl}backend-api/appointments/${id}`,
        id,
      );
      //condition
      if (response.status === 201) {
        return response.data.appointmentss;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// send messages
export const sendMessage = createAsyncThunk(
  "appointment",
  async (appointmentsData, thunkAPI) => {
    try {
      //response
      let response = await axios.post(
        `${BaseUrl}backend-api/appointments`,
        appointmentsData,
      );
      //condition
      if (response.status === 201) {
        handleSuccess("Send Appointment successfull !");
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// delete appointments
export const deleteAppointment = createAsyncThunk(
  "appointment",
  async (id, thunkAPI) => {
    try {
      let response = await axios.delete(
        `${BaseUrl}backend-api/appointments/${id}`,
      );
      if (response.status === 201) {
        handleSuccess("delete successfull !");
        return response.data.appointments;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
